import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useTenant } from "../../context/TenantContext";
import { captureViewport, screenshotErrorMessage } from "../../features/screenshot";
import SupportFab from "./SupportFab";
import SupportTicketModal from "./SupportTicketModal";
import "./SupportWidget.scss";

/**
 * Globálne tlačidlo „Nahlásiť chybu" dostupné na každej obrazovke pre
 * prihláseného používateľa (admin, manažér, vodič, zákazník).
 *
 * Volá `useAuth()` sám — `App` to urobiť nemôže, lebo je rodičom
 * `AuthProvider`. Rovnaký vzor ako route guardy v `App.js`.
 */
function SupportWidget() {
  const { isLoggedIn, authLoading, userId, userRole } = useAuth();
  const { tenant } = useTenant();

  const [isOpen, setIsOpen] = useState(false);
  const [fabHidden, setFabHidden] = useState(false);
  const [capturing, setCapturing] = useState(false);
  const [screenshot, setScreenshot] = useState(null);
  const [screenshotError, setScreenshotError] = useState(null);

  if (authLoading || !isLoggedIn) return null;

  const otvor = async () => {
    setCapturing(true);
    setScreenshot(null);
    setScreenshotError(null);

    // Poradie je dôležité: najprv skryť tlačidlo, nechať prehliadač prekresliť,
    // až potom snímať — a modál otvoriť až po snímke, aby v nej neskončil.
    setFabHidden(true);
    await new Promise((r) => requestAnimationFrame(r));
    await new Promise((r) => requestAnimationFrame(r));

    try {
      setScreenshot(await captureViewport());
    } catch (err) {
      setScreenshotError(screenshotErrorMessage(err));
    } finally {
      setFabHidden(false);
      setCapturing(false);
      setIsOpen(true);
    }
  };

  return (
    <>
      {/* Tlačidlo sa skrýva len počas snímania a keď je otvorený jeho vlastný
          modál. Nad cudzími modálmi musí ostať viditeľné a klikateľné. */}
      <SupportFab
        onClick={otvor}
        hidden={fabHidden || isOpen}
        busy={capturing}
      />
      <SupportTicketModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        screenshot={screenshot}
        screenshotError={screenshotError}
        user={{ userId, userRole }}
        prevadzka={tenant}
      />
    </>
  );
}

export default SupportWidget;
